import styles from "./HandoverNoteButton.module.scss";
import { Icon, IconType } from "../../../../common/icons/Icon";

/**
 * NotesIcon defaults to black, which is invisible on the planner's dark glass, and its
 * path pins `color` as an attribute that CSS inheritance cannot reach past.
 */
const ICON_COLOR = "rgba(255, 255, 255, 0.7)";

interface IHandoverNoteButtonProps {
  onClick: () => void;
}

/**
 * The hand-over affordance for a day nobody has written on yet: a single button
 * riding the search row. There is no content to justify a band of its own until
 * somebody writes something, and once they do the pinned card takes over.
 */
export const HandoverNoteButton = ({ onClick }: IHandoverNoteButtonProps) => {
  return (
    <button
      type="button"
      className={styles.root}
      onClick={onClick}
      aria-label="Добави бележка за деня"
      title="Бележка за деня"
    >
      <Icon
        type={IconType.AddNote}
        color={ICON_COLOR}
        width="28px"
        height="28px"
      />
    </button>
  );
};
